<template>
  <div class="result__items-wrapper">
    <div class="result__item">
      <div class="result__item-main">
        <picture class="result__item-cover">
          <source :data-srcset="`${getImagePrefixAddress + result.imageUrl}`" />

          <img
            class="lazyload result__item-img"
            src="/Themes/booking.ir/UI/Dist/images/default-image.svg"
            :alt="result.title"
          />
        </picture>

        <div class="result__item-more-detail c-execution-dates">
          <div class="result__item-description">
            <h2 class="result__item-title">
              <a :href="'/tour/' + result.slug" :title="result.title">
                {{ result.title }}
              </a>
            </h2>
            <ul class="fa-num">
              <li v-if="result.destinations && result.destinations.length">
                <label class="result__item-label hide-in-not-desktop">
                  {{ result.destinations.length > 1 ? "مقاصد" : "مقصد" }}
                </label>
                <i class="icon-map result__item-icon hide-in-desktop"></i>
                <span class="result__item-destination">
                  {{ result.destinations.join(" - ") }}
                </span>
              </li>

              <li v-if="result.accommodationNight">
                <label class="result__item-label hide-in-not-desktop">زمان برگزاری</label>
                <i class="icon-calendar result__item-icon hide-in-desktop"></i>
                <div>
                  <span class="result__item-night">
                    <span>
                      {{ result.accommodationNight }}
                    </span>
                    شب
                  </span>
                </div>
              </li>
              <li>
                <label class="result__item-label hide-in-not-desktop">مدت اقامت</label>
                <i class="icon-calendar result__item-icon hide-in-desktop" />

                <div class="result__item-night">
                  <i class="icon-moon" />
                  <span> {{ `${result.numberOfNightsOfStay} شب` }} </span>
                </div>
              </li>

              <li>
                <label class="result__item-label hide-in-not-desktop">ستاره هتل</label>
                <i class="icon-bed result__item-icon hide-in-desktop"></i>

                <div class="result__item-rate" v-for="(item, index) in result.hotelsStarRate" :key="index">
                  <div>
                    <i class="icon-star" />
                    <span>
                      {{ item }}
                    </span>
                  </div>
                </div>
              </li>

              <li>
                <label class="result__item-label hide-in-not-desktop">شرکت هواپیمایی</label>
                <i class="icon-plane result__item-icon hide-in-desktop"></i>

                <div class="result__item-destination" v-for="(item, index) in result.airLines" :key="index">
                  <img class="ml--1" :src="`${getImagePrefixAddress}airlineLogo/${item.airLineCode}.png`" alt="" />

                  <span>
                    {{ item.title }}
                  </span>
                </div>
              </li>

              <li>
                <label class="result__item-label hide-in-not-desktop">ساعت رفت</label>
                <i class="icon-plane result__item-icon hide-in-desktop"></i>

                <span class="hide-in-not-desktop">
                  {{ dateFormat(result.wentFlightDate, "HH:mm") }}
                </span>

                <span class="hide-in-desktop">
                  {{ `ساعت رفت: ${dateFormat(result.wentFlightDate, "HH:mm")}` }}
                </span>
              </li>

              <li>
                <label class="result__item-label hide-in-not-desktop">ساعت برگشت</label>
                <i class="icon-plane result__item-icon hide-in-desktop"></i>

                <span class="hide-in-not-desktop">
                  {{ dateFormat(result.returnFlightDate, "HH:mm") }}
                </span>

                <span class="hide-in-desktop">
                  {{ `ساعت برگشت: ${dateFormat(result.returnFlightDate, "HH:mm")}` }}
                </span>
              </li>

              <li v-if="result.destinations && result.labels.length" class="result__item-tags">
                <div
                  v-for="(item, index) in result.labels"
                  :key="index"
                  class="result__item-tag"
                  :class="`result__item-tag--${item.name}`"
                >
                  {{ item.display }}
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <!-- tour children container -->
      <div class="result__item-detail fa-num">
        <span class="result__item-label result__item-label--price">شروع قیمت برای هر نفر</span>

        <div>
          <div class="result__item-price" v-for="(item, index) in result.price" :key="index">
            <span>{{ formatPrice(item.price) }}</span>
            <label>{{ item.currency }}</label>
          </div>
        </div>

        <a
          v-if="!result.plans || result.plans.length === 1"
          :href="'/tour/' + result.slug"
          class="btn btn--secondary result__btn-reserve mt--2 mt-sm--0"
          title="خرید آنلاین"
        >
          <span>
            خرید آنلاین
          </span>
          <i class="icon-left"></i>
        </a>

        <button
          v-else
          class="btn btn--secondary-light result__btn-reserve result__btn-childrens mt--2 mt-sm--0"
          @click="() => (listVisibility = !listVisibility)"
          title="تاریخ‌های تور"
        >
          <span>
            تاریخ‌های تور
          </span>
          <i :class="listVisibility ? 'icon-up' : 'icon-down'"></i>
        </button>
      </div>

      <div v-if="listVisibility" class="result__item-child fa-num">
        <table class="hide-in-not-desktop">
          <thead>
            <tr>
              <th>تاریخ رفت</th>
              <th>تاریخ برگشت</th>
              <th>قیمت</th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="child in result.plans" :key="child.travelPackagePlaneId">
              <td>
                {{ dateFormat(child.startDate, "dddd, jDD jMMMM jYYYY") }}
              </td>

              <td>
                {{ dateFormat(child.endDate, "dddd, jDD jMMMM jYYYY") }}
              </td>

              <td>
                <div class="result__item-child-link-wrapper">
                  <div>
                    <div
                      v-for="(executionDatePrice, executionDateIndex) in child.minPrice.priceList"
                      :key="'executionDateIndex' + executionDateIndex"
                      class="result__item-price"
                    >
                      <span>{{ formatPrice(executionDatePrice.price) }}</span>
                      <label>{{ executionDatePrice.currency }}</label>
                    </div>
                  </div>

                  <a
                    :href="'/tour/' + result.slug + `/?selectedTourId=${child.travelPackagePlaneId}`"
                    class="btn btn--secondary result__btn-reserve"
                    title="خرید آنلاین"
                  >
                    <span>
                      خرید آنلاین
                    </span>
                    <i class="icon-arrow-left"></i>
                  </a>
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <!-- execution cards wrapper -->
        <div class="result__item-child-mobile hide-in-desktop">
          <!-- execution card -->
          <div v-for="child in result.plans" :key="child.travelPackagePlaneId + 'travelPackagePlan-mobile'">
            <div class="result__item-child-date-mobile">
              <div>
                <span>
                  {{ dateFormat(child.startDate, `dddd`) }}
                </span>
                <span>
                  {{ dateFormat(child.startDate, `jDD jMMMM jYYYY`) }}
                </span>
              </div>

              <div class="result__item-divider">
                <span />
                <i class="icon-plane-line" />
              </div>

              <div>
                <span>
                  {{ dateFormat(child.endDate, `dddd`) }}
                </span>
                <span>
                  {{ dateFormat(child.endDate, `jDD jMMMM jYYYY`) }}
                </span>
              </div>
            </div>
            <!-- footer card wrapper -->
            <div class="result__item-child-footer-mobile">
              <div>
                <div
                  v-for="(executionDatePrice, executionDateIndex) in child.minPrice.priceList"
                  :key="'executionDateIndex' + executionDateIndex"
                  class="result__item-price"
                >
                  <span>{{ formatPrice(executionDatePrice.price) }}</span>
                  <label>{{ executionDatePrice.currency }}</label>
                </div>
              </div>

              <a
                :href="'/tour/' + result.slug + `/?selectedTourId=${child.travelPackagePlaneId}`"
                class="btn btn--secondary result__btn-reserve"
                title="خرید آنلاین"
              >
                <span>
                  خرید آنلاین
                </span>
                <i class="icon-arrow-left"></i>
              </a>
            </div>
          </div>
        </div>
      </div>

      <ul class="hide">
        <li class="result__item-children" v-for="child in result.plans" :key="child.travelPackagePlaneId">
          <div class="result__item-children-date hide-in-not-desktop">
            <span>تاریخ شروع:</span>
            <span>{{ dateFormat(child.startDate, "dddd, jDD jMMMM jYYYY") }}</span>
          </div>

          <div class="result__item-children-date hide-in-desktop">
            <span>{{ dateFormat(child.startDate, "dddd, jDD jMMMM jYYYY") }}</span>
          </div>

          <div class="result__item-children-date hide-in-not-desktop">
            <span>تاریخ پایان:</span>
            <span>{{ dateFormat(child.endDate, "dddd, jDD jMMMM jYYYY") }}</span>
          </div>

          <div class="result__item-children-date hide-in-desktop">
            <span>{{ dateFormat(child.endDate, "dddd, jDD jMMMM jYYYY") }}</span>
          </div>

          <a :href="'/tour/' + result.slug + `/?selectedTourId=${child.travelPackagePlaneId}`" class="mr--auto">
            <span class="btn btn--secondary hide-in-not-desktop">
              جزییات و رزرو
              <i class="icon-arrow-left"></i>
            </span>

            <span class="btn btn--secondary btn--square hide-in-desktop">
              <i class="icon-left"></i>
            </span>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { dateFormat, formatPrice } from "@/helpers/tools";
import moment from "moment-jalaali";

export default {
  name: "ResultItem",

  props: {
    result: {
      type: Object,
    },
  },

  data() {
    return {
      firstRunDate: "",
      endRunDate: "",
      listVisibility: false,
    };
  },

  computed: {
    ...mapGetters(["getImagePrefixAddress", "getAddFavoriteUrl", "getIsUserAuthenticated"]),
  },

  methods: {
    dateFormat,
    ...mapActions(["showAlert"]),

    // return persian date
    persianDate(date, format = "jDD jMMMM ") {
      moment.loadPersian({
        dialect: "persian-modern",
      });
      return date ? moment(date).format(format) : "";
    },

    // format price
    formatPrice(price) {
      if (price) {
        return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return "";
      }
    },

    // return tour end run
    calcEndRunDate() {
      let endRunDate = "";

      if (this.result.childInfo && this.result.childInfo.length) {
        const firstChildInfo = this.result.childInfo.sort((a, b) => {
          return new Date(a.departureDate) - new Date(b.departureDate);
        });

        if (firstChildInfo.length > 0) {
          endRunDate = firstChildInfo[0].departureDate;
        }
      }

      return endRunDate;
    },

    // return tour first run
    calcFirstRunDate() {
      let firtRunDate = "";

      if (this.result.childInfo && this.result.childInfo.length) {
        const firstChildInfo = this.result.childInfo.sort((a, b) => {
          return new Date(a.arrivalDate) - new Date(b.arrivalDate);
        });

        if (firstChildInfo.length > 0) {
          firtRunDate = firstChildInfo[0].arrivalDate;
        }
      }

      firtRunDate = firtRunDate;

      return firtRunDate;
    },
  },

  created() {
    // this.firstRunDate = this.calcFirstRunDate();
    // this.endRunDate = this.calcEndRunDate();
  },
};
</script>
<style lang="scss">
@import "../style/modules/result.scss";
</style>
